import "./TabDeletePage.scss";

import { Image, Text } from "@fluentui/react-northstar";
import { pages } from "@microsoft/teams-js";
import { TeamsApplicationTypes } from "@teams/types";
import React, { useEffect } from "react";

import CoreRemoveImage from "../../_shared/assets/core-remove-tab.svg";
import AgileRemoveImage from "../../_shared/assets/remove-tab.svg";
import { HeroUnit } from "../../_shared/components/HeroUnit";
import { channelApi } from "../services/ChannelApi";
import { useTeamsContext } from "../state/TeamsContextProvider";

type TabDeletePageOptions = {
  title: string;
  applicationType: TeamsApplicationTypes;
};

export const TabDeletePage: React.FC<TabDeletePageOptions> = ({ title, applicationType }) => {
  const { teamsContext } = useTeamsContext();

  useEffect(() => {
    pages.config.registerOnRemoveHandler(event => {
      channelApi
        .tabRemoved(
          teamsContext,
          teamsContext?.team?.internalId || (teamsContext?.chat?.id as string),
          teamsContext.page.id
        )
        .finally(() => {
          event.notifySuccess();
        });
    });

    pages.config.setValidityState(true);
  });

  return (
    <div className="tab-delete">
      <Text content={title} size="large" weight="bold" color="brand" as="div" />

      <HeroUnit>
        <Image
          src={applicationType === "msteams" ? CoreRemoveImage : AgileRemoveImage}
          alt="Remove Tab Image"
        />
      </HeroUnit>
    </div>
  );
};
